"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _SkeletonWrapper = _interopRequireDefault(require("../SkeletonWrapper"));
var _Card = _interopRequireDefault(require("../Card"));
var _PaymentCardSkeletonStyled = require("./PaymentCardSkeletonStyled");
var _jsxRuntime = require("react/jsx-runtime");
const PaymentCardSkeleton = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Card.default, {
  withBorder: true,
  children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeletonStyled.CardStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardSkeletonStyled.CardInfoWrapStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardSkeletonStyled.CardInfoStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeletonStyled.CardTypeStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
            height: 16,
            width: 28
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_PaymentCardSkeletonStyled.CardDetailsStyled, {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeletonStyled.CardDetailsNameWrapStyled, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeletonStyled.CardDetailsNameStyled, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
                width: 140
              })
            })
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_PaymentCardSkeletonStyled.CardExpirationStyled, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
              width: 100
            })
          })]
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_SkeletonWrapper.default, {
        height: 43,
        width: 170
      })]
    })
  })
});
var _default = exports.default = PaymentCardSkeleton;